import Vue from 'vue';
import Router from 'vue-router';
import PageAnswer from '@/components/pages/answer/PageAnswer';
Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/index',
            name: 'pageAnswer',
            component: PageAnswer
        },
        {
            path: '*',
            name: 'redirect',
            redirect: '/index'
        }
    ]
});
